import { useQuery } from '@tanstack/react-query';
import { userService } from '@/services/userService';

export function useUser() {
  return useQuery({
    queryKey: ['user', 'account'],
    queryFn: async () => {
      const result = await userService.getAccount();
      if (!result.success) throw new Error(result.error);
      return result.data;
    },
    staleTime: 10 * 60 * 1000,
  });
}
